import React from 'react'
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import LocationOnIcon from '@mui/icons-material/LocationOn';

export default function Stats() {
    const stats = [
        {
            icon: <CurrencyRupeeIcon className="w-6 h-6 text-white" />,
            value: "50+ Crore",
            label: "Loan Applications Processed",
            bg: "bg-white text-gray-900",
            iconBg: "bg-slate-800",
        },
        {
            icon: <PeopleAltIcon className="w-6 h-6 text-orange-500" />,
            value: "10 Lakh+",
            label: "Users Served Across India",
            bg: "bg-slate-800 text-white",
            iconBg: "bg-white",
        },
        {
            icon: <LocationOnIcon className="w-6 h-6 text-white" />,
            value: "20+ Cities",
            label: "Growing Digital Presence",
            bg: "bg-white text-gray-900",
            iconBg: "bg-slate-800",
        },
    ];
    return (
        <section className="w-full py-12 sm:py-16 px-4 bg-gray-50">
            <div className="max-w-7xl mx-auto rounded-2xl p-4 sm:p-8">
                <div className="mb-10">
                    <p className="ms-text-secondary uppercase font-semibold text-lg">
                        Milestones
                    </p>

                    <h3 className="text-2xl sm:text-3xl lg:text-3xl font-bold leading-snug">
                       Growing with the Trust of Salaried Professionals
                    </h3>
                    {/* <p className=' text-gray-500 text-sm sm:text-base leading-8'>Adjust the sliders to calculate your EMI instantly with full transparency.</p> */}
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">

                    {stats.map((item, index) => (
                        <div
                            key={index}
                            className={`rounded-2xl p-6 sm:p-8 flex flex-col items-center justify-center shadow-md hover:shadow-lg transition ${item.bg}`}
                        >
                            {/* Icon */}
                            <div
                                className={`w-12 h-12 sm:w-14 sm:h-14 ${item.iconBg} rounded-full flex items-center justify-center mb-4`}
                            >
                                {item.icon}
                            </div>

                            {/* Value */}
                            <h2 className="text-3xl sm:text-4xl lg:text-4xl font-bold text-orange-500 mb-2">
                                {item.value}
                            </h2>

                            {/* Label */}
                            <p className="text-sm sm:text-base font-medium text-center">
                                {item.label}
                            </p>
                        </div>
                    ))}

                </div>
            </div>
        </section>
    )
}
